import React from 'react';
import { ICardProps } from '../../types/card';
import Typography from '../typography/Typography';
import ChevronIcon from '../icons/ChevronIcon';
import './card.scss';

export const Card = ({
  collapsibleIcon = true,
  collapsed = true,
  isGrey = false,
  titleColor = 'dark',
  chevronDirection,
  title,
  children,
  onCollapse,
  onClick,
}: ICardProps) => (
  <div className={`card ${isGrey ? 'card-grey' : ''} ${onClick ? 'card-clickable' : ''}`} data-testid="card" onClick={onClick}>
    <div className="card-header">
      <span className="card-title">
        <Typography data-testid="info_card-title" variant="h5" color={titleColor}>{title}</Typography>
      </span>
      {
        collapsibleIcon
          ? (
            <div className={`card-icon ${collapsed ? '' : 'card-icon-m'}`} onClick={() => onCollapse()}>
              <ChevronIcon height={14} direction={collapsed ? 'bottom' : 'top'} />
            </div>
          )
          : chevronDirection && <ChevronIcon height={14} direction={chevronDirection} color={titleColor} />
      }
    </div>
    <div className={`card-content card-content-expanded ${collapsed ? 'card-content-collapsed-m' : 'card-content-expanded-m'}`}>
      {children}
    </div>
  </div>
);
